{
  "es": {
    "validations": {
      "required": "El campo %{field} es obligatorio",
      "min": "El campo %{field} debe tener al menos %{min} caracteres",
      "max": "El campo %{field} debe tener como máximo %{max} caracteres",
      "alpha_dash": "The %{field} field may contain alpha-numeric characters as well as dashes and underscores",
      "email": "El campo %{field} debe ser una dirección de correo electrónico válida",
      "confirmed": "El campo %{field} no coincide",
      "numeric": "El campo %{field} solo puede contener caracteres numéricos",
      "between": "El campo %{field} debe estar entre %{min} y %{max}",
      "min_value": "El campo %{field} debe ser %{min} o más",
      "url": "El campo %{field} no es una URL válida"
    }
  }
}
